import { TypographyOptions } from '@mui/material/styles/createTypography';

export const typography: TypographyOptions = {
  fontFamily: '"Mona Sans", "Poppins", "Roboto", "Helvetica", "Arial", sans-serif',

  h1: {
    fontSize: '2.5rem',
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.005em',
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.57,
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.57,
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.66,
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 2.66,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  button: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.75,
    textTransform: 'none',
    letterSpacing: '0.02em',
  },
};

export const textStyles = {
  displayLarge: {
    fontSize: '3rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  displayMedium: {
    fontSize: '2.5rem',
    fontWeight: 600,
    lineHeight: 1.25,
  },
  displaySmall: {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  labelLarge: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.43,
  },
  labelMedium: {
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  labelSmall: {
    fontSize: '0.625rem',
    fontWeight: 500,
    lineHeight: 1.6,
  },
  hint: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.66,
    color: '#9E9E9E',
  },
  small: {
    fontSize: '0.625rem',
    fontWeight: 400,
    lineHeight: 1.5,
  },
} as const;
